import { ObjectFieldTemplateProps } from "@rjsf/utils";

function SliderTemplate(props: ObjectFieldTemplateProps, func: any) {
  return (
    <>
      <div className="section row">
        <div className="h3">{props.title}</div>
        
      </div>
    </>
  );
}

export default SliderTemplate;
